module.exports = __webpack_public_path__ + "static/img/icon_02.e7e8189.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/mobile/icon_02.png
// module id = Hbwp
// module chunks = 6